import React from 'react';
import Brick from './Brick';
import { ArticlesField, SalepointsField } from '../../components';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * add an article to a cart.
 *
 * [server_side]
 */
class CartAddArticleBrick extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, salepoints, articles } = props;

        if (!salepoints || !articles)
            return null;

        return (
            <>
                <FormGroup row>
                    <Label for="salepoint_id" className="text-v-center" sm={4}>
                        { t('workflows.bricks.cart.add.article.options.salepoint_id') }
                    </Label>
                    <Col sm={8}>
                        <SalepointsField salepoints={salepoints} name={`bricks[${this.position}].options.salepoint_id`} single />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="article_id" className="text-v-center" sm={4}>
                        { t('workflows.bricks.cart.add.article.options.article_id') }
                    </Label>
                    <Col sm={8}>
                        <ArticlesField onlyArticles articles={articles} name={`bricks[${this.position}].options.article_id`} single />
                    </Col>
                </FormGroup>
                {this.options?.article_id && (
                    <FormGroup row>
                        <Label for="variant_id" className="text-v-center" sm={4}>
                            { t('workflows.bricks.cart.add.article.options.variant_id') }
                        </Label>
                        <Col sm={8}>
                            <ArticlesField articles={articles.filter(a => a._id === this.options.article_id)} name={`bricks[${this.position}].options.variant_id`} single />
                        </Col>
                    </FormGroup>
                )}
                <FormGroup row>
                    <Label for="quantity" className="text-v-center" sm={4}>
                        { t('workflows.bricks.cart.add.article.options.quantity') }
                    </Label>
                    <Col sm={8}>
                        <Field component="input" type="number" name={`bricks[${this.position}].options.quantity`} className="form-control" />
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default CartAddArticleBrick;
